import { actionAlert } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import { SavedAddress } from "api/resources/payment/types"
import ErrorPage from "components/ErrorPage"
import TopNavigation from "components/Navigation/TopNavigation"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import useAuthCodeProcessor from "utils/hooks/useAuthCodeProcessor"
import useHideGlobalBottomNavigation from "utils/hooks/useGlobalHideBottomNavigation"
import useHideTopNavigation from "utils/hooks/useHideTopNavigation"

import BillingForm from "./BillingForm"
import OrderSummary from "./OrderSummary"

const CpatPaymentPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const productSlug = searchParams.get("product")

  useHideTopNavigation()
  useHideGlobalBottomNavigation()

  useAuthCodeProcessor({ shouldRedirectToLogin: false })

  const product = useQuery({
    queryFn: () =>
      api.products.getProduct({
        urlParams: { productSlug: productSlug || "" },
        params: {
          fields: ["prices"],
        },
      }),

    queryKey: ["product", productSlug],
  })

  useEffect(() => {
    const showAlertAndReload = async () => {
      if (searchParams.get("redirect_status") === "succeeded") {
        const newParams = new URLSearchParams(searchParams)
        newParams.delete("redirect_status")
        newParams.delete("paymentPlanId")
        newParams.delete("payment_intent")
        newParams.delete("payment_intent_client_secret")
        setSearchParams(newParams)

        await actionAlert.success({
          title: "Payment Successful!",
          duration: 5000,
          onClose: () => {},
        })

        window.location.reload()
      }
    }
    showAlertAndReload()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [address, setAddress] = useState<SavedAddress | null>(null)

  if (!productSlug || product.isError) {
    return <ErrorPage errorStatus={404} title="Product Not Found" />
  }

  return (
    <>
      <TopNavigation />
      <div className="flex min-h-screen w-full flex-col md:flex-row">
        <div className="flex-1 bg-white">
          <BillingForm
            onAddressCreated={value => {
              setAddress(value)
            }}
          />
        </div>
        <div className="flex-1 bg-surface-50">
          <OrderSummary address={address} />
        </div>
      </div>
    </>
  )
}

export default CpatPaymentPage
